import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TooltipContent, TooltipItem } from '@common/constants';

@Component({
  standalone: false,
  selector: 'common-tooltip-dialog',
  templateUrl: './tooltip-dialog.component.html',
  styleUrls: ['./tooltip-dialog.component.scss'],
})
export class TooltipDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: TooltipContent) {}

  get isOrdered(): boolean {
    return this.data?.ordered !== false;
  }

  // Generated markers duplicate what <ol>/<ul> already announce, so they're hidden from screen readers.
  get normalizedItems(): { marker: string; text: string; generated: boolean }[] {
    const ordered = this.isOrdered;
    return (this.data?.items ?? []).map((item, i) => {
      const entry: TooltipItem = typeof item === 'string' ? { text: item } : item;
      const label = entry.label?.trim();
      const marker = label || (ordered ? `${i + 1}.` : '•');
      return { marker, text: entry.text, generated: !label };
    });
  }
}
